import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRemove } from '@fortawesome/free-solid-svg-icons';

interface RenderItemsProps {
    items: string[];
    showAllSelectedValues: boolean;
    isPriceRangeMoved: boolean;
    minPrice: number | null;
    maxPrice: number | null;
    displayedMin: number;
    displayedMax: number;
    handleResetPriceRange: () => void;
    handleSelectedValueClick: (item: string) => void;
    handleToggleClick: () => void;
    handleClearAllSelectedValues: () => void;
    handleApplyFiltersButton: () => void;
    isApplyButtonVisible: boolean;
    selectedValuesChanged: boolean;
    blueColor: string;
    translate: (key: string) => string;
    setIsApplyButtonVisible: (value: boolean) => void;
}

const RenderItems: React.FC<RenderItemsProps> = ({
    items,
    showAllSelectedValues,
    isPriceRangeMoved,
    minPrice,
    maxPrice,
    displayedMin,
    displayedMax,
    handleResetPriceRange,
    handleSelectedValueClick,
    handleToggleClick,
    handleClearAllSelectedValues,
    handleApplyFiltersButton,
    isApplyButtonVisible,
    selectedValuesChanged,
    blueColor,
    translate,
    setIsApplyButtonVisible,
}) => {
    let itemsToDisplay;
    if (showAllSelectedValues) {
        itemsToDisplay = items;
    } else if (isPriceRangeMoved) {
        itemsToDisplay = items.slice(0, 5);
    } else {
        itemsToDisplay = items.slice(0, 6);
    }
    const filteredItems = itemsToDisplay.filter(
        (item) => !item.includes('Essential Special Service Tools_')
    );
    return (
        <>
            <Box>
                {isPriceRangeMoved && minPrice != null && maxPrice != null && (
                    <Button
                        className="chip-button"
                        style={{
                            border: '1px solid gray',
                            borderRadius: '4px',
                            padding: '5px 10px',
                            textAlign: 'center',
                            cursor: 'pointer',
                            color: 'white',
                            backgroundColor: '#066FEF',
                            textTransform: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            width: 'fit-content',
                        }}
                        onClick={handleResetPriceRange}
                        startIcon={
                            <FontAwesomeIcon
                                icon={faRemove}
                                size="xs"
                                style={{ fontSize: '10px' }}
                            />
                        }
                    >
                        <Typography fontSize={'14px'}>
                            ${displayedMin}
                        </Typography>
                        <Typography variant="body1">-</Typography>
                        <Typography fontSize={'14px'}>
                            ${displayedMax}
                        </Typography>
                    </Button>
                )}
                <Box
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '10px',
                        margin: '10px 0',
                        maxHeight: showAllSelectedValues ? '400px' : 'auto',
                        overflowY: showAllSelectedValues ? 'auto' : 'hidden',
                    }}
                >
                    {filteredItems.map((item) => (
                        <Button
                            key={item}
                            className="chip-button"
                            style={{
                                border: '1px solid gray',
                                borderRadius: '4px',
                                padding: '5px 10px',
                                textAlign: 'center',
                                cursor: 'pointer',
                                color: 'white',
                                backgroundColor: '#066FEF',
                                textTransform: 'none',
                                display: 'inline-block',
                                width: 'auto',
                            }}
                            startIcon={
                                <FontAwesomeIcon
                                    icon={faRemove}
                                    size="xs"
                                    style={{
                                        fontSize: '10px',
                                        display: 'inline-block',
                                    }}
                                />
                            }
                            onClick={() => handleSelectedValueClick(item)}
                        >
                            {item.includes('_') ? item.split('_').pop() : item}
                        </Button>
                    ))}
                </Box>

                {items.length + (isPriceRangeMoved ? 1 : 0) > 6 &&
                    !showAllSelectedValues && (
                        <Button
                            style={{
                                marginTop: 1,
                                fontSize: '10px',
                                fontWeight: '900',
                                color: blueColor,
                                marginBottom: '5px',
                            }}
                            onClick={handleToggleClick}
                            data-testid="selectedFiltersApplySection_moreButton"
                        >
                            {translate('more_txt')}
                        </Button>
                    )}

                {showAllSelectedValues &&
                    items.length + (isPriceRangeMoved ? 1 : 0) > 6 && (
                        <Button
                            style={{
                                marginTop: 1,
                                fontSize: '10px',
                                fontWeight: '900',
                                color: blueColor,
                                marginBottom: '5px',
                            }}
                            onClick={handleToggleClick}
                            data-testid="selectedFiltersApplySection_lessButton"
                        >
                            {translate('less_txt')}
                        </Button>
                    )}
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button
                    style={{
                        marginTop: 1,
                        fontSize: '12px',
                        fontWeight: '900',
                        color: blueColor,
                        borderColor: blueColor,
                        border: '1px solid',
                        padding: '5px',
                        textTransform: 'capitalize',
                        borderRadius: 5,
                    }}
                    onClick={handleClearAllSelectedValues}
                    id="selectedFiltersApplySection_clearAllButton"
                    data-testid="selectedFiltersApplySection_clearAllButton"
                >
                    {translate('ltl_ClearAllText')}
                </Button>

                <Button
                    style={{
                        fontSize: '12px',
                        fontWeight: '900',
                        textTransform: 'capitalize',
                        color: 'white',
                        backgroundColor: 'rgb(14, 22, 100)',
                        padding: '5px',
                        borderRadius: 5,
                    }}
                    id="selectedFiltersApplySection_applyButton"
                    onClick={() => {
                        handleApplyFiltersButton();
                        setIsApplyButtonVisible(false);
                    }}
                    data-testid="selectedFiltersApplySection_applyButton"
                >
                    {translate('apply_txt')}
                </Button>
            </Box>
        </>
    );
};

export default RenderItems;
